import type { ParseFileErrorLog } from './ParseFileErrorLog';

export class FileStatusDTO {
  public fileContributionId!: number;

  public fileName!: string;

  public providerId!: number;

  public s3FullPath!: string;

  public contributionDatetime!: string;

  public size!: number;

  public createdAt!: string; /* ISO 8601 string */

  public updatedAt!: string; /* ISO 8601 string */

  public asOfDate!: string[]; /* ISO 8601 string */

  public createdBy!: string;

  public updatedBy!: string;

  public status!: string;

  public currency!: string;

  public fileContributionUUID!: string;

  public fileType!: string;

  public teamId!: number;

  public parseErrors!: ParseFileErrorLog;
}
